// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3NsOg","errorLogs":"styles_errorLogs__SsqnQ"};